import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class IssueEventQueryCriteriaClass extends BaseCriteriaModel {
  hdr_guid?: Optional<string> = Optional.empty();
  line_guid?: Optional<string> = Optional.empty();
  action?: Optional<string> = Optional.empty();
  event_code?: Optional<string> = Optional.empty();
  id_user?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
}

export class IssueEventCriteriaModelQuery {
  query = '';

  constructor(issueEventCriteriaModel: IssueEventQueryCriteriaClass) {

    if (!issueEventCriteriaModel) {
      return;
    }

    this.query += issueEventCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += issueEventCriteriaModel.line_guid.filter(x => x !== '').map(x => '&line_guid=' + x).orElse('');
    this.query += issueEventCriteriaModel.action.filter(x => x !== '').map(x => '&action=' + x).orElse('');
    this.query += issueEventCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');
    this.query += issueEventCriteriaModel.id_user.filter(x => x !== '').map(x => '&id_user=' + x).orElse('');
    this.query += issueEventCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');

    this.query += '&status=' + issueEventCriteriaModel.status;
    this.query += '&orderBy=' + issueEventCriteriaModel.orderBy;
    this.query += '&order=' + issueEventCriteriaModel.order;
    this.query += '&offset=' + issueEventCriteriaModel.offset + '&limit=' + issueEventCriteriaModel.limit;
  }
}
